/* eslint eqeqeq: 0 */
import { STATUS_ACTIVE } from "../constants/teaserList";

export function overview(cid) {
  if (!cid) {
    return "/overview/";
  }
  return `/campaign/${cid}/overview/`;
}

export function monetization(cid) {
  if (!cid) {
    return "/monetization/";
  }
  return `/campaign/${cid}/monetization/`;
}

export function campaignCreate() {
  return "/campaign/create/";
}

export function campaignList() {
  return "/campaign/list/";
}

export function widgetCreate(cid) {
  return `/campaign/${cid}/widget/create/`;
}

export function widgetEdit(wid) {
  return `/widget/${wid}/update/`;
}

export function widgetList(cid) {
  return `/campaign/${cid}/widget/list/`;
}

export function announceList(cid, status) {
  const s = status == undefined ? STATUS_ACTIVE : status;
  if (!cid) {
    return `/announce/list/${s}/`;
  }
  return `/campaign/${cid}/announce/list/${s}/`;
}

export function payments() {
  return "/payments/";
}

export function paymentSuccess() {
  return "/payments/success/";
}

export function paymentFail() {
  return "/payments/fail/";
}

export function notFound() {
  return "/404";
}

export function notAvailable() {
  return "/503";
}

export function serverError() {
  return "/500";
}

export function campaignStatExport(id) {
  if (!id) {
    return "/campaigns/stat/export";
  }
  return `/campaigns/${id}/stat/export`;
}

export function informerStatExport(id) {
  return `/widgets/${id}/stat/export`;
}

export function teaserStatExport(id) {
  return `/announcements/${id}/stat/export`;
}

export function teaserListStatExport(cid) {
  if (!cid) {
    return "/announcements/stat/export";
  }
  return `/campaigns/${cid}/announcements/export`;
}
